import React, { useState } from 'react';
import UploadImageApi from '../../../../api/ImageUpload.api';

export default function ImageField({
  label,
  fieldName,
  value,
  onInputChange,
  isGallery = false,
  removeFromList = null,
}) {
  // State for loading and error
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Shared function to handle both upload and drop
  const handleFileChange = async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    setIsLoading(true); // Start loading
    setError(null); // Reset any previous error

    try {
      const res = await UploadImageApi(formData, 'image');

      onInputChange({
        target: {
          name: fieldName,
          value: res.data.imageUrl,
        },
      });

      setIsLoading(false); // End loading
    } catch (error) {
      console.error(error);
      setError('Image upload failed. Please try again.'); // Set error
      setIsLoading(false); // End loading
    }
  };

  // Handle drag over (to prevent the default behavior of the browser)
  const handleDragOver = (e) => {
    e.preventDefault(); // Prevent the default behavior
  };

  // Handle drop event
  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files; // Get the dropped files

    if (files && files[0]) {
      handleFileChange(files[0]);
    }
  };

  // Handle file input change (upload)
  const handleUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      handleFileChange(file);
    }
  };

  return (
    <div
      className="col-lg-6 col-12"
      onDragOver={handleDragOver} // Enable dragging over the card
      onDrop={handleDrop} // Handle drop on the card
    >
      <div className="card my-2 position-relative">
        {/* Overlay to block the UI during upload */}
        {isLoading && (
          <div className="overlay">
            <div className="spinner-border text-white" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        <div className="card-header p-0 custom_image_card">
          {/* Show uploaded image with blackout during upload */}
          {value && <img src={value} alt="Uploaded" className="card-img-top" />}
          {isLoading && <div className="image-blackout" />}
        </div>

        <div className="card-body" style={{ minHeight: '130px' }}>
          <div className="form-label">{label}</div>

          {/* Input or gallery view */}
          <input
            className="form-control my-3"
            type="file"
            accept="image/*"
            onChange={handleUpload}
            placeholder="Upload Image"
            disabled={isLoading} // Disable input when uploading
          />

          {removeFromList && (
            <div className="d-flex justify-content-center w-100">
              <button
                type="button"
                className="btn btn-danger mt-2 remove_button_height"
                onClick={removeFromList}
              >
                Remove Image
              </button>
            </div>
          )}

          {/* Show error message if upload failed */}
          {error && (
            <div className="text-danger mt-2">
              <small>{error}</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
